import React from 'react';
import ReactDOM from 'react-dom';
import './firebase';
import './i18n';
import App from './App'; // or the path to your top-level component
import { DragDropContext } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import "./polyfills";

const AppWithDragDropContext = DragDropContext(HTML5Backend)(App);

ReactDOM.render(
  <AppWithDragDropContext />,
  document.getElementById('root')
);
